"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformTokenHtmlToObject = void 0;
const errors_1 = require("../../errors");
const transformations_1 = require("../../transformations");
const lib_1 = require("../../lib");
const transformTokenHtmlToObject = (html, flippers) => {
    const $ = (0, lib_1.loadCheerio)(html);
    const token = $('[e-token]');
    validateToken(token);
    return {
        type: (0, transformations_1.desanitize)(token.attr('e-token') || ''),
        template: (0, transformations_1.deserialize)(token.attr('token-template') || '""'),
        content: (0, transformations_1.deserialize)(token.attr('token-content') || '{}'),
        meta: (0, transformations_1.deserialize)(token.attr('token-meta') || '{}'),
        style: (0, transformations_1.desanitize)(token.attr('style') || ''),
        class: (0, transformations_1.desanitize)(token.attr('class') || ''),
        name: unescapeHtml(token.text(), flippers),
    };
};
exports.transformTokenHtmlToObject = transformTokenHtmlToObject;
function validateToken(token) {
    if (token.length === 0) {
        throw new errors_1.MissingMandatoryAttributeError('There is no e-token attribute on the given tag');
    }
    if (token.get(0).tagName !== 'span') {
        throw new errors_1.InvalidTokenTagError('Token tag name must be span!');
    }
}
function unescapeHtml(html, flippers) {
    if (flippers.includes('editor_fix_xss_in_esl_token_name')) {
        return html.replace(/&gt;/g, '>').replace(/&lt;/g, '<').replace(/&amp;/g, '&');
    }
    return html.replace(/&lt;/g, '<');
}
//# sourceMappingURL=transform-token-html-to-object.js.map